import { ModalContentToggler } from '@components'

import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import { useMemo } from 'react'

import { CustomerModalState } from '../../enums/CustomerModalState'
import { CustomerModalSubmitActionType } from '../../enums/customerModalSubmitActionType'
import { CustomerType } from '../../enums/customerType'
import { Contact } from '../../types/contact'
import { CustomerFormContextProvider } from './contexts/customerFormContext'
import { CustomerFormInitialValues } from './types/customerForm/customerFormInitialValues'
import { getCustomerModalStates } from './utils/getCustomerModalStates'

interface CustomerModalProps extends ModalProps {
  customer?: Contact
  defaultCustomerType?: CustomerType
  initialValues?: CustomerFormInitialValues
  onSubmit: (customer: Contact) => void
  submitActionType: CustomerModalSubmitActionType
}

const CustomerModalComponent = ({
  customer,
  defaultCustomerType,
  initialValues,
  onSubmit,
  submitActionType,
  ...modalProps
}: CustomerModalProps) => {
  const initialCustomerType = defaultCustomerType ?? CustomerType.Company
  const customerModalSubmitActionType = submitActionType ?? CustomerModalSubmitActionType.Create

  const modalTitle = customer?.name
  const customerModalStates = useMemo(() => getCustomerModalStates(modalTitle), [modalTitle])

  return (
    <CustomerFormContextProvider
      customer={customer}
      initialCustomerType={initialCustomerType}
      initialValues={initialValues}
      onSubmit={onSubmit}
      submitActionType={customerModalSubmitActionType}
    >
      <ModalContentToggler<CustomerModalState>
        closable={false}
        initialState={initialCustomerType}
        states={customerModalStates}
        withTransition={false}
        {...modalProps}
      />
    </CustomerFormContextProvider>
  )
}

export const CustomerModal = withModalConditionalRender(CustomerModalComponent)
